<template>
  <table class="cells">
    <tr v-for="row in cells" :key="row.rowIndex" class="row">
      <td
        class="cell"
        :class="{ alive: cell.alive }"
        v-for="cell in row.cells"
        :key="cell.columnIndex"
        @click="toggleCell(cell)"
      ></td>
    </tr>
  </table>
  <GameControls
    class="game-controls"
    :playing="playInterval !== null"
    @reset="resetCells"
    @randomize="randomizeCells"
    @stepForward="stepForward"
    @play="play"
    @stop="stop"
    v-model:interval-value="intervalValue"
  />
  <GameStats
    class="game-stats"
    :tick="tick"
    :tickDuration="tickDuration"
    :realTickDuration="realTickDuration"
    :stateComputeDuration="stateComputeDuration"
  />
</template>

<script>
import { ref, nextTick } from "vue";
import GameControls from "./GameControls.vue";
import GameStats from "./GameStats.vue";

let prevTickDone = new Date().getTime();

export default {
  components: { GameControls, GameStats },
  props: {
    verticalSize: { type: Number, default: 50 },
    horizontalSize: { type: Number, default: 50 },
  },
  setup(props) {
    const nonReactiveCells = [];
    const neighbours = [];

    for (let rowIndex = 0; rowIndex < props.verticalSize; rowIndex++) {
      const prevRowIndex =
        (rowIndex + props.verticalSize - 1) % props.verticalSize;
      const nextRowIndex = (rowIndex + 1) % props.verticalSize;

      nonReactiveCells[rowIndex] = { rowIndex: rowIndex, cells: [] };
      neighbours[rowIndex] = [];

      for (
        let columnIndex = 0;
        columnIndex < props.horizontalSize;
        columnIndex++
      ) {
        const prevColumnIndex =
          (columnIndex + props.horizontalSize - 1) % props.horizontalSize;
        const nextColumnIndex = (columnIndex + 1) % props.horizontalSize;

        nonReactiveCells[rowIndex].cells[columnIndex] = {
          columnIndex: columnIndex,
          alive: false,
        };

        neighbours[rowIndex][columnIndex] = [
          [prevRowIndex, prevColumnIndex],
          [prevRowIndex, columnIndex],
          [prevRowIndex, nextColumnIndex],
          [rowIndex, prevColumnIndex],
          [rowIndex, nextColumnIndex],
          [nextRowIndex, prevColumnIndex],
          [nextRowIndex, columnIndex],
          [nextRowIndex, nextColumnIndex],
        ];
      }
    }

    const cells = ref(JSON.parse(JSON.stringify(nonReactiveCells)));

    return { cells, nonReactiveCells, neighbours };
  },
  data() {
    return {
      tick: 0,
      tickDuration: 0,
      realTickDuration: 0,
      stateComputeDuration: 0,
      playInterval: null,
      intervalValue: 100,
    };
  },
  watch: {
    intervalValue: function () {
      if (this.playInterval !== null) {
        this.stop();
        this.play();
      }
    },
  },
  methods: {
    toggleCell(cell) {
      cell.alive = !cell.alive;
      this.nonReactiveCells = JSON.parse(JSON.stringify(this.cells));
    },
    resetCells() {
      this.cells.forEach((row) => {
        row.cells.forEach((cell) => {
          cell.alive = false;
        });
      });
      this.nonReactiveCells = JSON.parse(JSON.stringify(this.cells));
    },
    randomizeCells() {
      this.cells.forEach((row) => {
        row.cells.forEach((cell) => {
          cell.alive = Math.random() > 0.5;
        });
      });
      this.nonReactiveCells = JSON.parse(JSON.stringify(this.cells));
    },
    async stepForward() {
      const stepForwardStart = new Date().getTime();
      const nextState = [];

      // For each row
      this.nonReactiveCells.forEach((row, rowIndex) => {
        nextState[rowIndex] = { rowIndex: rowIndex, cells: [] };

        // For each cell
        row.cells.forEach((cell, columnIndex) => {
          let aliveNeighboursCount = 0;

          // For each neighbour
          this.neighbours[rowIndex][columnIndex].forEach((neighbourCoords) => {
            if (
              this.nonReactiveCells[neighbourCoords[0]].cells[
                neighbourCoords[1]
              ].alive
            ) {
              aliveNeighboursCount += 1;
            }
          });

          nextState[rowIndex].cells[columnIndex] = {
            columnIndex: columnIndex,
            alive:
              (cell.alive &&
                (aliveNeighboursCount === 2 || aliveNeighboursCount === 3)) ||
              (!cell.alive && aliveNeighboursCount === 3),
          };
        });
      });

      const nextStateComputed = new Date().getTime();

      this.nonReactiveCells = nextState;
      this.cells = this.nonReactiveCells;
      this.tick += 1;
      this.stateComputeDuration = nextStateComputed - stepForwardStart;

      // const stateUpdated = new Date().getTime();

      await nextTick();

      const nextTickDone = new Date().getTime();
      this.tickDuration = nextTickDone - stepForwardStart;
      this.realTickDuration = nextTickDone - prevTickDone;
      prevTickDone = nextTickDone;

      // console.log(
      //   `Total step duration: ${
      //     this.tickDuration
      //     // }ms (currStateCloneDuration: ${
      //     //   currStateCloneEnd - stepForwardStart
      //   }ms (nextStepComputedDuration ${
      //     nextStateComputed - stepForwardStart
      //   }ms) (stateUpdatedDuration ${
      //     stateUpdated - nextStateComputed
      //   }ms) (nextTickDuration ${nextTickDone - stateUpdated}ms)`
      // );
    },
    play() {
      if (this.playInterval !== null) {
        return;
      }
      this.playInterval = window.setInterval(() => {
        this.stepForward();
      }, this.intervalValue);
    },
    stop() {
      if (this.playInterval !== null) {
        window.clearInterval(this.playInterval);
        this.playInterval = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.cells {
  border-collapse: collapse;
  flex: 0 1 auto;
  align-self: center;
}
.row {
  height: 10px;
}
.cell {
  box-sizing: border-box;
  border: 1px solid gray;
  width: 10px;
  padding: 0;

  &.alive {
    background-color: black;
  }
}
</style>
